var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative block font-sans"},[(_vm.$slots.label || _vm.$slots.inputAccessory)?_c('div',{staticClass:"flex justify-between mb-1"},[_vm._t("label"),_vm._v(" "),_vm._t("inputAccessory")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-row flex-wrap items-center"},[_vm._t("input"),_vm._v(" "),(_vm.inputSuffix)?_c('span',{class:[
        'px-1',
        'text-body-posts',
        {
          'text-dark-text-100': _vm.darkMode === false,
          'text-light-text-100': _vm.darkMode === true,
          'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
        },
      ]},[_vm._v("\n      "+_vm._s(_vm.inputSuffix)+"\n    ")]):_vm._e()],2),_vm._v(" "),_vm._t("focusedAfterInputAccessory"),_vm._v(" "),(_vm.inputDescriptor)?_c('p',{class:[
      'm-0',
      'pt-2',
      'px-1 tablet-portrait:px-4',
      'text-body-extra-small',
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
        'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
      },
    ],attrs:{"id":_vm.inputDescriptorId}},[_vm._v("\n    "+_vm._s(_vm.inputDescriptor)+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }